import { render, staticRenderFns } from "./Complete.vue?vue&type=template&id=70ec8720&scoped=true&"
import script from "./Complete.vue?vue&type=script&lang=js&"
export * from "./Complete.vue?vue&type=script&lang=js&"
import style0 from "./Complete.vue?vue&type=style&index=0&id=70ec8720&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.8_cache-loa_04cfefe4e5633ef36867eab2fc0c6666/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ec8720",
  null
  
)

export default component.exports